module.exports = __webpack_public_path__ + "static/media/text-input-preview.bc88793f.png";